import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
Vue.use(Vuetify);
const opts = {};
export default new Vuetify(opts);
// import Vue from 'vue';
// import Vuetify from 'vuetify/lib';
// import 'vuetify/dist/vuetify.min.css'
// Vue.use(Vuetify);
//
// export default new Vuetify({
// });




// WEBPACK FOOTER //
// ./src/plugins/vuetify.js